import { TLPageId, TLStoreSnapshot } from "tldraw"

type DrawingBlob = {
  key: string
  pageId: TLPageId
  data: TLStoreSnapshot
}

// Save user data to Netlify Blobs
export async function saveToBlobStore(key: string, value: any) {
  console.log("Saving to blob store", key, value)
  const response = await fetch("/.netlify/functions/blobHandler", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ key, value }),
  })
  return await response.json()
}

// Read data from blob store
export async function readFromBlobStore(key: string) {
  console.log("Reading from blob store", key)
  const response = await fetch(`/.netlify/functions/blobHandler?key=${key}`)
  const { value } = await response.json()
  return value
}
